import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { useEffect,useState } from 'react';
import dayjs from 'dayjs';
import { Typography } from '@mui/material';
import '../../../../cssfiles/homepage.css'
import CustomTooltip from '../../../CommonComponents/CustomTooltip';

export default function Valuedatacard(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const livedata = useSelector((state) => state.mainpagedata.livedata);

    const [optionsmin, setOptionsMin] = useState(0);
    const [optionsmax, setOptionsMax] = useState(0);
    const [optionstimemin, setOptionsTimeMin] = useState(0);
    const [optionstimemax, setOptionsTimeMax] = useState(0);
    const [widgetnamedisplay, setWidgetName] = useState(0);
    const [value, setValue] = useState(0)
    const [time, setTime] = useState("01-01-1970 00:00:00")
    
    
    //console.log("valuecardprops ",props.widgetprop.props.extended.tagprops[0].tagname)
    
    useEffect(() => {
        const tagProperties = props.widgetprop.props.extended.tagprops;
        var widgetname = props.widgetprop.widgetname;
        tagProperties.forEach(chartType => {
            
            if (tagcollectionvalue.hasOwnProperty(chartType.tagname)) {
                var nestedvalue = tagcollectionvalue[chartType.tagname]
                //console.log("nested value in cardwidget",nestedvalue)
                var sum = 0.0;
                var min = 10000000000;
                var max = 0.0;
                var mintime = 0.0;
                var maxtime = 0.0;
                var options = { timeZone: "Asia/Kolkata" };
                    for(var i=0;i<nestedvalue.length;i++){
                        if(Number(nestedvalue[i].y) > max){
                            max = Number(nestedvalue[i].y);
                            var currentmaxformatteddate = new Date(nestedvalue[i].x);
                            var maxformatteddate = currentmaxformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric",hour: "numeric",minute: "numeric",second: "numeric" });
                            maxtime = maxformatteddate;
                        }else if(Number(nestedvalue[i].y) < min){
                            min = Number(nestedvalue[i].y);
                            var currentminformatteddate = new Date(nestedvalue[i].x);
                            var minformatteddate = currentminformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric",hour: "numeric",minute: "numeric",second: "numeric" });
                            mintime = minformatteddate
                        }
                    }
                //console.log("inside Card Widget min",min)
                //console.log("inside Card Widget max",max)
                //console.log("inside Card Widget mintime",mintime)
                //console.log("inside Card Widget max",maxtime)
                setOptionsMin(min);
                setOptionsMax(max);
                setOptionsTimeMin(mintime);
                setOptionsTimeMax(maxtime);
              //  setWidgetName(widgetname)
                
            }
        })
       
        
      },[props.widgetprop, tagcollectionvalue])

    useEffect(() => {
        if(livedata.length) {
            for(let i=0; i<livedata.length; i++) {
                //console.log("value card ",livedata[i].TagId, props.widgetprop.props.extended.tagprops[0].tagid)
                if(parseInt(props.widgetprop.props.extended.tagprops[0].tagid) === parseInt(livedata[i].TagId)) {
                    //console.log("livedata[i].value ",livedata[i].value)
                    setValue(livedata[i].value.toFixed(2))
                    var date = new Date(livedata[i].timestamp * 1000)
                    var month = date.getMonth()+1;
                    var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                    setTime(timestamp)
                }
            }
        }
    },[livedata])

    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <div style={{display: 'flex', height: '88%', width: '95%', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{display: 'flex', flexDirection: 'column', padding: '10px',alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                    <CustomTooltip title={value} offset={[10,-30]} placement={'bottom-end'}> 
                        <Typography style={{fontFamily:"Roboto", fontSize:"58px",fontWeight:500, color: 'var(--PrimaryText)', maxWidth: '90%',/*width: '90%', */ whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis'}}> {value} </Typography>
                    </CustomTooltip>         
                </div>
            </div>
            <div style={{display: 'flex', alignItems:'center', justifyContent: 'center'}}>
                <Typography style={{fontFamily:"Roboto", fontSize:"18px",fontWeight:400, color: 'var(--PrimaryText)'}}> {time} </Typography>
            </div>
            {/*<div style={{position:"inline-flex",display:"flex", flexDirection:"row", paddingTop:"60px",alignItems:'baseline',paddingLeft:"20px"}}>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Minimum</div>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,paddingLeft:"206px"}}>{optionsmin}</div>
            </div>
            <div style={{color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400,paddingLeft:"235px"}}>{optionstimemin}</div>

            <div style={{position:"inline-flex",display:"flex", flexDirection:"row", paddingTop:"40px",alignItems:'baseline',paddingLeft:"20px",paddingTop:"50px"}}>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Maximum</div>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,paddingLeft:"206px"}}>{optionsmax}</div>
            </div>
            <div style={{color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400,paddingLeft:"235px"}}>{optionstimemax}</div>*/}
        </div>
    )
}